// src/components/Modals/ModalFinalPhase/FinalPhaseModal.jsx
import React, { useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";
import { toast } from "react-hot-toast";

const FinalPhaseModal = ({ open, onClose, participantes, onSave }) => {
  const [participant1, setParticipant1] = useState(null); // Por defecto "Por Definir"
  const [participant2, setParticipant2] = useState(null); // Por defecto "Por Definir"
  const [nroFecha, setNroFecha] = useState(1);
  const [tagFinal, setTagFinal] = useState(""); // Estado para tag_final
  const [idtypephase, setIdTypePhase] = useState(1); // Nuevo campo numérico

  const handleSave = () => {
    if (
      nroFecha &&
      idtypephase &&
      (participant1 !== "" || participant2 !== "")
    ) {
      onSave({
        participant1: participant1 || null,
        participant2: participant2 || null,
        nroFecha,
        tagFinal,
        idtypephase, // Nuevo campo agregado
      });
    } else {
      toast.error(
        "Debe seleccionar al menos un participante o marcar como pendiente, una fecha y un tipo de fase válido."
      );
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <DialogTitle>Crear Match Fase Final</DialogTitle>
        <DialogContent>
          <div className="flex flex-col gap-4 mt-2">
            {/* Tipo de Fase */}
            <TextField
              label="Tipo de Fase (1 o 2)"
              type="number"
              value={idtypephase}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value === 1 || value === 2) {
                  setIdTypePhase(value);
                } else {
                  toast.error("Solo se permite 1 o 2 como valores.");
                }
              }}
              fullWidth
            />

            {/* Participante 1 */}
            <Select
              value={participant1}
              onChange={(e) => setParticipant1(e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value={null}>Por Definir</MenuItem>
              {participantes.map((p) => (
                <MenuItem key={p.idparticipant} value={p.idparticipant}>
                  <div className="flex items-center gap-2">
                    <img
                      src={p.Institution.image_path}
                      alt={p.Institution.abrev}
                      className="w-8 h-8"
                    />
                    <span>{p.idparticipant}</span> -{" "}
                    <span>{p.Institution.abrev}</span> -{" "}
                    <span>{p.Institution.name}</span>
                  </div>
                </MenuItem>
              ))}
            </Select>

            {/* Participante 2 */}
            <Select
              value={participant2}
              onChange={(e) => setParticipant2(e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value={null}>Por Definir</MenuItem>
              {participantes.map((p) => (
                <MenuItem key={p.idparticipant} value={p.idparticipant}>
                  <div className="flex items-center gap-2">
                    <img
                      src={p.Institution.image_path}
                      alt={p.Institution.abrev}
                      className="w-8 h-8"
                    />
                    <span>{p.idparticipant}</span> -{" "}
                    <span>{p.Institution.abrev}</span> -{" "}
                    <span>{p.Institution.name}</span>
                  </div>
                </MenuItem>
              ))}
            </Select>

            {/* Número de Fecha */}
            <TextField
              label="Número de Fecha"
              type="number"
              value={nroFecha}
              onChange={(e) => setNroFecha(e.target.value)}
              fullWidth
            />

            {/* Campo Tag Final */}
            <TextField
              label="Etiqueta Final (Tag Final)"
              type="text"
              value={tagFinal}
              onChange={(e) => setTagFinal(e.target.value)}
              fullWidth
            />
          </div>

          <div className="flex justify-end mt-4">
            <Button onClick={handleSave}>Guardar</Button>
          </div>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default FinalPhaseModal;
